module.exports = __webpack_public_path__ + "assets/img/landing-investment.79c1dd0b.jpg";